(function ($) {
	$(document).ajaxComplete(function (event, request, settings) {
		const { data } = settings;
		if (data.indexOf("action=woof_draw_products") >= 0) {
			const offsetTop = $(document).find(".toggle-filter").offset().top;
			$("html, body").animate({ scrollTop: offsetTop }, "slow");
		}
		jQuery(".woof_products_top_panel_ul a").on("click", function () {
			const href = window.location.href.split("?")[0];
			var tax = jQuery(this).attr("data-tax");
			var queryDict = {};
			location.search
				.substr(1)
				.split("&")
				.forEach(function (item) {
					queryDict[item.split("=")[0]] = item.split("=")[1];
				});

			if (queryDict.hasOwnProperty(tax)) {
				delete queryDict[tax];
			}

			var search = [];
			var searchKeys = Object.keys(queryDict);
			var l = searchKeys.length;
			for (let index = 0; index < l; index++) {
				var k = searchKeys[index];
				search.push(k + "=" + queryDict[k]);
			}

			window.location.replace(href + "?" + search.join("&"));
		});
	});
})(jQuery);

